import styled, { css } from "styled-components";

export const ListItem = styled.li`
  display: flex;
  flex-shrink: 0;
`;

export const Button = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  height: 48px;
  padding: ${({ theme }) => theme.space["space-4"]};
  cursor: pointer;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};

  &:active {
    background-color: ${({ theme }) =>
      theme.colorTokens.component.input.pressed};
  }

  ${({ isActive, theme }) =>
    isActive &&
    css`
      box-shadow: inset 0 -2px 0 ${theme.colorTokens.content.link};
    `};
`;
